G.WorldMapLvls = function(map, editorMode) {

    G.PoolGroup.call(this, G.WorldMapLvlButton, [editorMode]);
    this.position = map.position;

    this.lvlBtnCoords = this.getLvlBtnCoords()
        .sort(function(a, b) {
            return a.mapY - b.mapY;
        });

    G.sb("onWindowOpened").add(this.lockInput, this);
    G.sb("onWindowClosed").add(this.unlockInput, this);

    map.signals.onMapScrolled.add(G.Helpers.callOnThreshold(30, this.updateButtons, this));
};

G.WorldMapLvls.prototype = Object.create(G.PoolGroup.prototype);



G.WorldMapLvls.prototype.editorRefreshData = function() {

    this.lvlBtnCoords.forEach(function(e, i) {
        if (e.btnObj) this.detachButton(i);
    }, this);



    this.lvlBtnCoords = this.getLvlBtnCoords();
    this.updateButtons();
    /*.sort(function(a,b){
		return a.mapY - b.mapY;
	});*/

};

G.WorldMapLvls.prototype.getLvlBtnCoords = function() {
    var numberOfLevels = G.Helpers.levelDataMgr.getNumberOfLevels();
    var result = [];

    //here gets slow in IE11 (too much calculation)
    for (var lvlIndex = 0; lvlIndex < numberOfLevels; lvlIndex++) {
        var lvlData = G.Helpers.levelDataMgr.getLevelByIndex(lvlIndex);
        result.push({
            mapY: lvlData.mapY,
            lvlIndex: lvlIndex,
            btnObj: null,
            lvlData: lvlData,
        });
    }

    return result;
};

G.WorldMapLvls.prototype.getButtonObj = function(lvlNr) {

    for (var i = 0; i < this.children.length; i++) {
        var btn = this.children[i];
        if (btn.lvlIndex == lvlNr) {
            return btn;
        }
    }

};

G.WorldMapLvls.prototype.updateButtons = function() {

    var howDeep = this.y - game.height;

    var result = [];

    //to not loop to the end of array when when btns are showed
    var wasPushed = false;
    var wasPushedAndNoBtns = false;

    for (var i = 0; i < this.lvlBtnCoords.length; i++) {

        if (howDeep - G.l(40) + this.lvlBtnCoords[i].mapY < 0 && howDeep + game.height + G.l(40) + this.lvlBtnCoords[i].mapY > 0) {
            if (this.lvlBtnCoords[i].btnObj === null) {
                this.attachButton(i);
            }
            wasPushed = true;
        } else {

            //if (wasPushedAndNoBtns) break;

            if (this.lvlBtnCoords[i].btnObj !== null) {
                this.detachButton(i);
            } else {
                wasPushedAndNoBtns = wasPushed;
            }

        }

    }

};

G.WorldMapLvls.prototype.attachButton = function(index) {

    this.lvlBtnCoords[index].btnObj = this.getFreeElement();
    this.lvlBtnCoords[index].btnObj.init(this.lvlBtnCoords[index].lvlIndex, this.lvlBtnCoords[index].lvlData);

};

G.WorldMapLvls.prototype.detachButton = function(index) {

    this.lvlBtnCoords[index].btnObj.kill();
    this.lvlBtnCoords[index].btnObj = null;

};

G.WorldMapLvls.prototype.unlockInput = function() {
    this.ignoreChildInput = false;
};

G.WorldMapLvls.prototype.lockInput = function() {
    this.ignoreChildInput = true;
};